var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotesPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 3,
    r: 1.9,
    stroke: "currentColor",
    strokeWidth: 1.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 10.2C0.8 7.7 2.3 6.4 4.5 6.4C6.7 6.4 8.2 7.7 8.2 10.2",
    stroke: "currentColor",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesPerson);
export default __webpack_public_path__ + "static/media/notes-person.4aca3e9be0a886b4f0eefbb29fc59766.svg";
export { ForwardRef as ReactComponent };